module.exports = __webpack_public_path__ + "static/img/product_02.bbfd0b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/product_02.png
// module id = neSh
// module chunks = 34